import { Component, Input, OnInit } from '@angular/core';
import { OerebService } from '../../core/oereb-api';
import { HttpResponse } from '@angular/common/http';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { GrundstueckId } from '../../core/gb-api';
import { OerebStateService } from '../services/oereb-state.service';
import { Observable } from 'rxjs';
import { sanatizedSaveAs } from '../../shared/functions/file.functions';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'cap-oereb-title-action-buttons',
  templateUrl: './oereb-title-action-buttons.component.html',
  imports: [AsyncPipe, TranslatePipe]
})
export class OerebTitleActionButtonsComponent implements OnInit {
  hasData: Observable<boolean>;

  @Input()
  gsId: GrundstueckId;

  constructor(
    private oerebService: OerebService,
    private translateService: TranslateService,
    private oerebStateService: OerebStateService
  ) {}

  ngOnInit() {
    this.hasData = this.oerebStateService.hasData$;
  }

  downloadPdf() {
    this.oerebService.getPdf(this.gsId.id, this.translateService.currentLang, 'response').subscribe((response: HttpResponse<Blob>) => {
      const filename = response.headers.get('Content-Disposition').split('filename=')[1].replace(/"/g, '').trim();
      sanatizedSaveAs(response.body, filename);
    });
  }
}
